import { createAction } from "redux-actions";
import { GET_PAYROLL } from "../constants";
import { feathersFindDataAll } from "../services";

export const getUsersPayroll = createAction(GET_PAYROLL, (cedule) => feathersFindDataAll('users-company',{ cedule, state: true} )());
